import { LayoutOne } from "@/layouts";
import { Container, Row, Col } from "react-bootstrap";
import AboutPageSection from "@/components/aboutUs/aboutPageSection";
import CompanyOverviewSection from "@/components/aboutUs/companyoverviewsection";
import PremiumExcellenceSection from "@/components/aboutUs/PremiumExcellenceSection";
import DirectorDetails from "@/components/aboutUs/directordetail";
import LatestBlogFeeds from "@/components/latestBlogFeeds";
import OurTestimonial from "@/components/ourTestimonial";
import FaqSection from "@/components/aboutUs/faqSection";
import OurGroupSection from "@/components/ourGroup";
import SeoHead from "@/components/SeoHead";
import aboutFaq from "@/data/faq/about";
import { getLatestBlogs } from "@/lib/blog";
import { ABOUT_SCHEMA } from "@/lib/aboutSchema";

function AboutUs({ latestBlogs = [] }) {
  return (
    <>
      <SeoHead
        path="/about"
        fallbackTitle="About Siddhivinayak Group | Real Estate Nagpur"
        fallbackDescription="Nagpur real estate developer by Kunal Padole Group — premium 2/3 BHK flats and RL plots in Ram Nagar, Hanuman Nagar, Narsala, Bahadura, Ambazari."
        seo={{
          seo_title: "About Siddhivinayak Group | Real Estate Nagpur",
          meta_description: "Nagpur real estate developer by Kunal Padole Group — premium 2/3 BHK flats and RL plots in Ram Nagar, Hanuman Nagar, Narsala, Bahadura, Ambazari.",
          focus_keyword: "about Siddhivinayak Group",
          secondary_keywords: [
            "real estate developer in Nagpur",
            "Kunal Padole Group real estate",
            "Siddhivinayak Group Nagpur",
            "premium residential projects in Nagpur",
            "RL plots in Nagpur",
            "2 BHK 3 BHK flats in Nagpur",
            "Dr Kunal G Padole founder",
          ],
          canonical_url: "",
          schema_json: ABOUT_SCHEMA,
          og_image: "/img/og/siddhivinayak-group-og.jpg",
          og_title: "About Siddhivinayak Group | Real Estate Nagpur",
          og_description: "Premium 2 & 3 BHK flats, plotted developments, and RERA-approved RL plots across Nagpur. Founded by Dr. Kunal G. Padole.",
        }}
        publisherName="Siddhivinayak Group"
        speakable_selectors={[
          ".section-title",
          ".faq-question",
        ]}
      />
      <LayoutOne topbar={true} showHeading={false}>
        <AboutPageSection sectionSpace="pb-90" />
        <CompanyOverviewSection sectionSpace="pb-90" />

        {/* Render the new section right here or wherever you prefer */}
        <PremiumExcellenceSection sectionSpace="pb-90" />
        <DirectorDetails sectionSpace="pb-90" />
        <OurTestimonial sectionSpace="pt-115 pb-90" />
        <FaqSection sectionSpace="pt-115 pb-90" />
        <LatestBlogFeeds
          sectionSpace="pt-115 pb-90"
          data={latestBlogs}
        />
        <div className="section-bg-1">
          <OurGroupSection />
        </div>
      </LayoutOne>
    </>
  );
}

export async function getStaticProps() {
  let latestBlogs = [];
  try {
    latestBlogs = await getLatestBlogs(6);
  } catch (err) {
    latestBlogs = [];
  }
  return {
    props: { latestBlogs },
    revalidate: 600,
  };
}

export default AboutUs;